import React, { useEffect, useRef } from "react";
import Spritesheet from 'react-responsive-spritesheet';

import img from './images/1.png';
import sound from './sounds/bang.wav';

const audio = new Audio(sound);

const Explosion = (props) => {

    const { top, left, isMute } = props;

    const spritesheeInstance = useRef(null);

    useEffect(() => {
        if (audio && !audio.paused) {
            audio.pause();
        }
        if (spritesheeInstance && spritesheeInstance.current) {
            spritesheeInstance.current.goToAndPlay(1);
            spritesheeInstance.current.play();
        }
        if (audio && isMute !== true) {
            audio.currentTime = 0;
            audio.play();
        }
    });

    return <div className="position-absolute " style={{
        top: top,
        left: left,
        userSelect: 'none',
        zIndex: 999,
        transform: 'scale(1.5)',
        pointerEvents: 'none',
        transformOrigin: '100% 100%'
    }}>
        <Spritesheet
            image={img}
            widthFrame={64}
            heightFrame={64}
            steps={12}
            fps={12}
            autoplay={spritesheeInstance.current ? false : true}
            loop={true}
            getInstance={spritesheet => {
                spritesheeInstance.current = spritesheet;
            }}
            onLoopComplete={spritesheet => {
                if (props.stop) {
                    props.stop();
                }
                spritesheet.pause();
            }}
        />
    </div>;

}
export default Explosion;





